import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_provider/provider/")({
  beforeLoad: async ({ context }) => {
    throw redirect({ to: "/provider/home" });
  },
});
